import { render, staticRenderFns } from "./medeelel.vue?vue&type=template&id=00874022&scoped=true&"
import script from "./medeelel.vue?vue&type=script&lang=js&"
export * from "./medeelel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00874022",
  null
  
)

export default component.exports